export default __webpack_public_path__ + "static/media/Walker's Belt of Passing Spirits.1565dc23.jpg";